import RankingShow from '../components/ranking/Show'

export default [
  { name: 'RankingShow', path: '/ranking', components: {'RankingTab':RankingShow}, meta: { requiresAuth: true } }
]
